// Strips inline style declarations out of cell HTML before a new value is
// stamped on. Two traps a naive /color:.*?(;|")/ falls into:
//
//  - `background-color:#123456` contains the substring `color:#123456`, so an
//    unanchored match eats the neighbour's value and leaves a dangling
//    `background-`. Every match is anchored to a property boundary: string
//    start, `;`, or whitespace.
//  - A declaration with no trailing `;` (`style="color:#1155cc"`, the shape
//    Google Sheets pastes) ends at the closing quote, so a `"` terminator
//    swallows it and breaks the tag. The value stops before any quote instead.
//
// Leftover `;`/whitespace residue is inert CSS and is left alone; collapsing it
// would mean parsing the style attribute, which the callers re-parse anyway.
export const stripStyleDecls = (html: string, cssProps: string[]): string =>
  html.replaceAll(
    new RegExp(`(^|[;"'\\s])(?:${cssProps.join("|")}):[^;"']*`, "gi"),
    "$1",
  );
